var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-cascader", {
    ref: _vm.refs,
    attrs: {
      placeholder: "请选择题库",
      "popper-class": _vm.refs,
      disabled: _vm.disabled,
      options: _vm.datas,
      "collapse-tags": "",
      props: _vm.props,
      filterable: "",
      "show-all-levels": _vm.showAllLevels,
      clearable: _vm.clearable
    },
    on: {
      "visible-change": _vm.visibleChange,
      "expand-change": _vm.visibleChange,
      change: _vm.checkChange
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var data = ref.data
          return _c(
            "div",
            { staticClass: "node-label" },
            [
              _vm.type == "pc"
                ? [
                    data.type == 1
                      ? _c("i", {
                          staticClass: "iconfont icon-book-openshu-fankai",
                          staticStyle: { "font-size": "15px" }
                        })
                      : _c("i", {
                          staticClass: "iconfont icon-wenjianjia",
                          staticStyle: {
                            "font-size": "15px",
                            "margin-top": "-1px"
                          }
                        })
                  ]
                : _vm._e(),
              _vm._v("\n    " + _vm._s(data.name) + "\n  ")
            ],
            2
          )
        }
      }
    ]),
    model: {
      value: _vm.ids,
      callback: function($$v) {
        _vm.ids = $$v
      },
      expression: "ids"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a253229", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a253229","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pc/components/shared/PaperAuthCascader.vue
// module id = 618
// module chunks = 14